/* global axios */
import ApiClient from './ApiClient';

class SummaryReportsAPI extends ApiClient {
  constructor() {
    super('summary_reports', { accountScoped: true, apiVersion: 'v2' });
  }

  getTeamReports({ since, until, businessHours } = {}) {
    return axios.get(`${this.url}/team`, {
      params: {
        since,
        until,
        business_hours: businessHours,
      },
    });
  }

  getAgentReports({ since, until, businessHours } = {}) {
    return axios.get(`${this.url}/agent`, {
      params: {
        since,
        until,
        business_hours: businessHours,
      },
    });
  }

  getInboxReports({ since, until, businessHours } = {}) {
    return axios.get(`${this.url}/inbox`, {
      params: {
        since,
        until,
        business_hours: businessHours,
      },
    });
  }

  getLabelReports({ since, until, businessHours, inboxIds, teamIds } = {}) {
    const params = { since, until };
    if (businessHours !== undefined) {
      params.business_hours = businessHours;
    }
    if (inboxIds?.length) {
      params.inbox_ids = inboxIds;
    }
    if (teamIds?.length) {
      params.team_ids = teamIds;
    }

    return axios.get(`${this.url}/label`, { params });
  }
}

export default new SummaryReportsAPI();
